const roleAccess = {
  1: ['Dashboard', 'Sales', 'Purchases', 'Time Tracking', 'Estimates', 'Expenses', 'Loans', 'Payroll', 'Form 16', 'Taxs & Forms', 'Attendance', 'Settings'],
  2: ['Dashboard', 'Sales', 'Purchases', 'Time Tracking', 'Estimates', 'Expenses', 'Loans', 'Payroll', 'Form 16', 'Taxs & Forms', 'Attendance', 'Settings'],
  3: ['Dashboard', 'Sales', 'Purchases', 'Time Tracking', 'Estimates', 'Expenses', 'Loans', 'Payroll', 'Form 16', 'Taxs & Forms', 'Attendance', 'Settings'],
  4: ['Dashboard', 'Sales', 'Purchases', 'Time Tracking', 'Estimates', 'Expenses', 'Loans', 'Payroll', 'Form 16', 'Taxs & Forms', 'Attendance', 'Settings'],
  5: ['Dashboard', 'Sales', 'Purchases', 'Time Tracking', 'Estimates', 'Expenses', 'Loans', 'Payroll', 'Form 16', 'Taxs & Forms', 'Attendance', 'Settings'],
  6: ['Dashboard', 'Sales', 'Purchases', 'Time Tracking', 'Estimates', 'Expenses', 'Loans', 'Payroll', 'Form 16', 'Taxs & Forms', 'Attendance', 'Settings'],
  7: ['Dashboard', 'Sales', 'Purchases', 'Time Tracking', 'Estimates', 'Expenses', 'Loans', 'Payroll', 'Form 16', 'Taxs & Forms', 'Attendance', 'Settings']
};

const menu =  [
  { label: 'Dashboard', key: 'paybooks/dashboard', icon: 'DashboardOutlined' },
  { label: 'Sales', key: '/paybooks/sales/estimates', icon: 'InvoicesOutlined' },
  { label: 'Purchases', key: 'paybooks/purchases/vendors', icon: 'InvoicesOutlined' },
  { label: 'Estimates', key: 'paybooks/estimates', icon: 'EstimatesOutlined' },
  { label: 'Expenses',  key: 'paybooks/expenses', icon: 'ExpensesOutlined' },
  { label: 'Time Tracking', key: 'paybooks/timetracking', icon: 'Timetohire' },
  { label: 'Payroll', key: 'paybooks/payroll/dashboard', icon: 'BillsOutlined' },
  { label: 'Form 16', key: 'paybooks/form16', icon: 'BillsOutlined' },
  { label: 'Taxs & Forms', key: 'paybooks/taxs', icon: 'BillsOutlined' },
  { label: 'Attendance', key: 'paybooks/attendance', icon: 'BillsOutlined' },
  { label: 'Loans', key: 'paybooks/loans', icon: 'BillsOutlined' },
  { label: 'Settings', key: 'paybooks/settings', icon: 'SettingsOutlined' }
];
  
function getInvoiceMenuForRoles(user) {
  const accessibleMenus = new Set();
  user?.roles?.forEach(roleId => {
    const accessibleItems = roleAccess[roleId] || [];
    accessibleItems?.forEach(item => accessibleMenus.add(item));
  });
  return menu.filter(menuItem => accessibleMenus.has(menuItem.label));
}

  
export {
  getInvoiceMenuForRoles
};
  